// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Component, Fragment } from 'react';
import '../styles/containers/Users.css';
import { connect } from 'react-redux';
import { Glyphicon } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import InfiniteScroll from 'react-infinite-scroller';
import * as Service from '../services/UsersService';
import {
  generateKeyStr,
  isMobileResolution,
  openLink,
} from '../infrastructure/utils/common';
import UserFilterForm from '../components/forms/UserFilterForm';
import { setFilterData, setFilterFlag } from '../actions/userActions';
import TableSortingElem from '../infrastructure/TableSorting';
import TopPanel from '../components/utils/TopPanel';
import Spinner from '../components/utils/Spinner';
import UserList from '../components/users/UserList';
import MobileTopPanelActions from '../components/utils/MobileTopPanelActions';
import MobileListSorter from '../components/utils/MobileListSorter';
import { mapFromUserToUserCSV } from '../infrastructure/utils/users';

const initialState = {
  usersLoaded: false,
  allUsers: false,
  sw: false,
  deactive: false,
  activeSort: null,
  filterData: undefined,
  avaliableSort: [],
  listKey: generateKeyStr(),
  users: null,
  filter: 'all',
  token: null,
  isMobileFilterSelected: false,
  isMobileSortSelected: false,
  csvUsers: [],
};

class Users extends Component {
  term = '';

  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterData, activeFilter, activateFilter } = this.props;
    document.documentElement.style.overflow = 'hidden';
    if (activeFilter) {
      this.loadFirstUsers(filterData);
      activateFilter(false);
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.loadFirstUsers();
    }
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = 'auto';
    this.setState({ deactive: true });
  }

  handleUserClick = (event, url) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { filterData } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history, setFilter, activateFilter } = this.props;
    setFilter(filterData);
    activateFilter(true);
    openLink(event, url, history, !isMobileResolution());
  };

  onUserSearched = user => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    history.push(`/users/${user}`);
  };

  getFilteredUsers = filterData => {
    this.setState({ filterData });
    this.loadFirstUsers(filterData);
  };

  changeSort = name => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { activeSort, avaliableSort, filterData, onlyAdmin } = this.state;
    // @ts-ignore
    const { onlyVendor } = this.state;
    let sort = null;
    if (activeSort.name === name) {
      sort = {
        ...activeSort,
        up: !activeSort.up,
      };
      this.setState({ activeSort: sort });
    } else {
      sort = avaliableSort.find(s => s.name === name);
      this.setState({ activeSort: sort });
    }
    this.loadUsers({
      token: 0,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      onlyAdmin,
      firstLoad: true,
      order: sort,
      filterData,
      onlyVendor,
    });
  };

  changeSortBySelect = (name, up) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { avaliableSort, filterData, onlyAdmin } = this.state;
    // @ts-ignore
    const { onlyVendor } = this.state;
    const sort = avaliableSort.find(s => s.name === name);
    if (!sort) return;
    sort.up = up;
    this.setState({ activeSort: sort });
    this.loadUsers({
      token: 0,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      onlyAdmin,
      firstLoad: true,
      order: sort,
      filterData,
      onlyVendor,
    });
  };

  loadCSVUsers = async () =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject) => {
      try {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        const { activeSort, filterData } = this.state;
        const data = await Service.getAllUsers(activeSort, filterData, 0, true);
        const csvUsers = data.map(mapFromUserToUserCSV);
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        this.setState({ csvUsers }, () => resolve());
      } catch (e) {
        console.log(e);
        reject();
      }
    });

  loadMoreUsers = async () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { token, onlyAdmin, activeSort, filterData } = this.state;
    // @ts-ignore
    const { onlyVendor } = this.state;
    this.loadUsers({
      token,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      onlyAdmin,
      firstLoad: false,
      order: activeSort,
      filterData,
      onlyVendor,
    });
  };

  loadUsers = async ({ token, firstLoad, order, filterData }) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const data = await Service.getAllUsers(order, filterData, token);
    if (data.length === 0) {
      if (firstLoad) {
        this.setState({ users: [] });
      }
      this.setState({ allUsers: true });
      return;
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { deactive } = this.state;
    if (!deactive) {
      if (firstLoad) {
        this.setState({
          users: data,
          token: data.length,
          activeSort: order,
          filterData,
          avaliableSort: [
            new TableSortingElem({ name: 'name', isString: true, up: true }),
            new TableSortingElem({ name: 'email', isString: true, up: true }),
            new TableSortingElem({ name: 'name', isString: true, up: false }),
            new TableSortingElem({ name: 'email', isString: true, up: false }),
          ],
          listKey: generateKeyStr(),
          usersLoaded: true,
          allUsers: false,
        });
      } else {
        this.setState(state => ({
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          users: state.users.concat(data),
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          token: state.token + 25,
        }));
      }
    }
  };

  async searchUserByEmail(val) {
    this.term = val;
    if (val === '') {
      this.loadFirstUsers(false);
      return;
    }
    if (val.length < 3) {
      return;
    }
    const data = await Service.searchByEmail(val);
    const res = data.Items.map(user => ({
      label: `${user.name}(${user.email})`,
      value: user.id,
    }));
    if (this.term === val) {
      this.setState({
        users: data.Items,
        allUsers: true,
        listKey: generateKeyStr(),
      });
    }
    // eslint-disable-next-line consistent-return
    return res.slice(0, 20);
  }

  async loadFirstUsers(filterData) {
    this.loadUsers({
      token: 0,
      firstLoad: true,
      order: new TableSortingElem({ name: 'name', isString: true }),
      filterData,
    });
  }

  render() {
    const {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      usersLoaded,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      users,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      activeSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      allUsers,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      listKey,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      filterData,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileFilterSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileSortSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      avaliableSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      csvUsers,
    } = this.state;
    if (!usersLoaded) {
      return <Spinner />;
    }
    return (
      <Fragment>
        <TopPanel>
          <h1
            className='col-md-6 col-sm-4 col-xs-3'
            style={{ marginTop: '0px' }}
          >
            <span className='fas fa-user' />
            BACHers
          </h1>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <MobileTopPanelActions
              isFilterSelected={isMobileFilterSelected}
              isSortSelected={isMobileSortSelected}
              onFilterClick={() =>
                this.setState({
                  isMobileFilterSelected: !isMobileFilterSelected,
                })
              }
              onSortClick={() =>
                this.setState({ isMobileSortSelected: !isMobileSortSelected })
              }
            />
          }
        </TopPanel>
        <div className='data-container'>
          <UserFilterForm
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            users={users}
            filterUsers={this.getFilteredUsers}
            filterData={filterData}
            isMobileFilterSelected={isMobileFilterSelected}
            csvUsers={csvUsers}
            loadCSVUsers={this.loadCSVUsers}
          />
          <MobileListSorter
            isSortSelected={isMobileSortSelected}
            activeSort={activeSort}
            availableSort={avaliableSort}
            changeSortBySelect={this.changeSortBySelect}
          />
          <div className='clearfix' />
          {users.length > 0 ? (
            <div
              key={listKey}
              className='table-box tab-cont small-height infinity-list'
            >
              <InfiniteScroll
                pageStart={0}
                loadMore={this.loadMoreUsers}
                useWindow={false}
                hasMore={!allUsers}
                loader={
                  <Glyphicon key={0} glyph='refresh' className='spinning' />
                }
              >
                <UserList
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  users={users}
                  activeSort={activeSort}
                  changeSort={this.changeSort}
                  handleOnClick={this.handleUserClick}
                />
              </InfiniteScroll>
            </div>
          ) : (
            <h2>Users list is empty</h2>
          )}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    filterData: state.users.userFilters,
    activeFilter: state.users.activeFilter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setFilter: data => dispatch(setFilterData(data)),
    activateFilter: data => dispatch(setFilterFlag(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);
